export const TAB_CONFIG = [
    { key: 'basic', labelKey: 'agent.form.tabs.basic' },
    { key: 'persona', labelKey: 'agent.form.tabs.persona' },
] as const;

export const EMBEDDING_OPTIONS = [
    { id: 'sm3', name: 'sm3' },
    { id: 'ad2', name: 'ad2' },
    { id: 'lg3', name: 'lg3' },
] as const;
